import * as React from 'react'
import { connect } from 'react-redux'
import { getRecording, confirmDeleteRecording } from 'features/Recordings/Recordings.actions'
import { Recording } from './Recording'

export interface IRecordingPageContainerProps {
  params: {
    recordingId: string
  }
}

const stateToProps = ({}, { params: { recordingId } }: IRecordingPageContainerProps) => {
  return {
    recordingId,
  }
}

export const dispatchToProps = {
  getRecording,
  confirmDeleteRecording,
}

export const RecordingPage = connect(stateToProps, dispatchToProps)(Recording) as React.SFC<
  IRecordingPageContainerProps
>



// WEBPACK FOOTER //
// src/pages/Recording/Recording.container.ts